import { createServerFn } from '@tanstack/react-start';
import { setHeaders } from 'vinxi/http';
import { z } from 'zod/v4';

import { getAdminChartsData, getAdminStats } from '@/db/queries';
import { cache } from '@/lib/cache';
import { getCategoryDistributionByHour, getRecentTrends } from '@/lib/trends';
import { debug } from '@/utils';

import { env } from '@/env';
import { CategoryByHour, RecentTrend } from '@/types';

export const fetchRecentTrends = createServerFn({ method: 'GET' }).handler(async () => {
  debug('fetchRecentTrends');

  setHeaders({
    // 'Cache-Control': `public, max-age=${env.CACHE_TTL_SECONDS}, stale-while-revalidate=${env.CACHE_TTL_SECONDS}`,
    'Cache-Control': `public, max-age=0, must-revalidate, s-maxage=${env.CACHE_TTL_SECONDS}, stale-while-revalidate=${env.MAX_STALE_WHILE_REVALIDATE_SECONDS}`,
  });

  return await cache<RecentTrend[]>('recentTrends', getRecentTrends);
});

export const fetchCategoryDistributionByHour = createServerFn({
  method: 'GET',
}).handler(async () => {
  setHeaders({
    'Cache-Control': `public, max-age=0, must-revalidate, s-maxage=${env.CACHE_TTL_SECONDS}, stale-while-revalidate=${env.MAX_STALE_WHILE_REVALIDATE_SECONDS}`,
  });

  return await cache<CategoryByHour[]>('trendsByHourlyCategories', getCategoryDistributionByHour);
});

export const fetchAdminStats = createServerFn({ method: 'GET' }).handler(async () => {
  return await getAdminStats();
});

export const fetchAdminChartsData = createServerFn({ method: 'GET' }).handler(async () => {
  return await getAdminChartsData();
});

export const fetchAdminTableTopics = createServerFn({ method: 'GET' })
  .validator(z.number())
  .handler(async (ctx) => {
    const recentHours = ctx.data;

    if (!recentHours) {
      throw new Error('Date range is required');
    }

    return await getRecentTrends(recentHours);
  });
